exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".po-box{overflow:hidden}.po-box .po-cont{position:relative;display:inline-block;transform-origin:0 0}.po-box .po-cont .luckyCoinImg{position:absolute;left:35px;top:100px;z-index:5;width:4rem}.po-box .po-cont .products{position:absolute;left:0;top:0;z-index:10}.po-box .po-cont .products .item{position:absolute;white-space:nowrap}.po-box .po-cont .products .item span{font-size:34px}.po-box .po-cont .products .btn span{font-size:26px}.po-box .po-cont .golden-bubble{position:absolute;right:0;bottom:0}.po-box .po-cont .close{position:absolute;left:0;top:0;z-index:15}.mobile .po-cont .luckyCoinImg{left:40px;top:105px;width:10rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1287357a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popup/DynamicPo.vue
// module id = 396
// module chunks = 0